import { Platform } from 'react-native';
import isWeb from './isWeb';

const ua = (navigator && navigator.userAgent) || '';

const isAndroid = isWeb
    ? ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
    : Platform.OS === 'android';

export default isAndroid;
